import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const QualityBad = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox={props.viewBox ? props.viewBox : "0 0 65 65"}
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={props.size}
            height={props.size}>
            <rect x="0.875" width="64" height="64" rx="32"   fill={props.bgColor ? props.bgColor: "white"} />
            <path fillRule="evenodd" clipRule="evenodd" d="M43.3663 35.4837C44.0446 36.1779 44.0446 37.3036 43.3663 37.9978L34.1031 47.4793C33.7774 47.8127 33.3356 48 32.875 48C32.4144 48 31.9726 47.8127 31.6469 47.4793L22.3837 37.9978C21.7054 37.3035 21.7054 36.1779 22.3837 35.4837C23.062 34.7894 24.1617 34.7894 24.84 35.4837L31.1382 41.9303L31.1382 17.7778C31.1382 16.7959 31.9158 16 32.875 16C33.8342 16 34.6118 16.7959 34.6118 17.7778L34.6118 41.9303L40.91 35.4837C41.5883 34.7894 42.688 34.7894 43.3663 35.4837Z" 
              fill={props.color ? props.color: "white"} />
        </SvgStyled>
    );
};

export default QualityBad;
